// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TabSwitchIcons_wrapper__1etJT","opt":"TabSwitchIcons_opt__130Gc","active":"TabSwitchIcons_active__3cdt_"};